import { apiGet } from './api'
import type { DashboardStats, ActivityLogEntry } from '../types'

export interface ProjectDashboardStats {
  recentActivity: ActivityLogEntry[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalizeProjectStats(data: any): DashboardStats {
  return {
    activeProjects: 1,
    totalSystems: data.systems?.total ?? 0,
    totalEquipment: data.equipment?.total ?? 0,
    checklistCompletion: data.checklists?.completionPercentage ?? 0,
    totalChecklists: data.checklists?.total ?? 0,
    completedChecklists: data.checklists?.byStatus?.Complete ?? 0,
    issuesByCategory: data.issues?.byCategory ?? {},
    issuesByStatus: {
      open: data.issues?.byStatus?.Open ?? 0,
      inProgress: data.issues?.byStatus?.InProgress ?? 0,
      pendingResponse: data.issues?.byStatus?.PendingResponse ?? 0,
      resolved: data.issues?.byStatus?.Resolved ?? 0,
      closed: data.issues?.byStatus?.Closed ?? 0,
      deferred: data.issues?.byStatus?.Deferred ?? 0,
    },
    openIssues: data.issues?.open ?? 0,
    totalIssues: data.issues?.total ?? 0,
    recentActivity: (data.recentActivity || []).map((a: any) => ({
      id: a.id,
      entityType: a.entityType,
      entityId: a.entityId,
      action: a.action,
      description: a.description,
      performedBy: a.performedByName ?? a.performedBy,
      performedAt: a.createdAt,
      projectId: a.projectId,
    })),
  }
}

export const dashboardApi = {
  getGlobalStats(): Promise<DashboardStats> {
    return apiGet<DashboardStats>('/dashboard/stats')
  },

  async getProjectSpecificStats(projectId: string): Promise<DashboardStats> {
    const data = await apiGet(`/dashboard/project/${projectId}/stats`)
    return normalizeProjectStats(data)
  },

  // Keep legacy method
  getProjectStats(): Promise<DashboardStats> {
    return apiGet<DashboardStats>('/dashboard/stats')
  },

  getProjectDashboard(projectId: string): Promise<ProjectDashboardStats> {
    return apiGet<ProjectDashboardStats>(`/dashboard/project/${projectId}/stats`)
  },
}
